<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      {{ district.name }}
      <router-link class="btn btn-primary" :to="{ name: 'district-edit', params: { district_id: district.id }}">Редактировать район</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'city-details', params: { city_id: $route.params.city_id } }">← Назад к Районам</router-link>
    </div>

    <div v-if="false" class="row">
      <div class="col-md-6">

        <!-- Name -->
        <div class="form-group">
          <label>Название</label>
          <p>{{ district.name }}</p>
        </div>

      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-view :district-id="district.id"></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import { getDistrict } from '@/services/district.service'
import helpers from '@/helpers'

export default {
  name: 'district-details',
  data () {
    return {
      district: {
        id: null,
        name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.district_id !== undefined) {
      this.district.id = this.$route.params.district_id

      getDistrict(this.district.id).then((response) => {
        this.district = response.data
      })
    }
  },
  methods: {
    toMoney: helpers.toMoney
  }
}
</script>


// WEBPACK FOOTER //
// DistrictDetails.vue?1b7fd64d